/**
 * @requires @function `isMobile`
 * @requires @var `onReady` (object)
 */
(function() {

	//	======================================================================  //
	//	Config
	//	======================================================================  //

	var phoneNumbers = '.js-phone-no';
	var $phoneNumbers = $(phoneNumbers);

	//	======================================================================  //
	//	Functions
	//	======================================================================  //

	/**
	 * @function `disablePhoneLinksOnComputers`
	 *
	 * Unwraps all phone links from their `<a>` tags.
	 *
	 * 1. Quick escape: only run the function for devices
	 *    that are not mobile phones.
	 * 2. Quick escape: stop the function if no phone links
	 *    are found.
	 *
	 * @param $phoneLinks (node) | the `<a>` tags.
	 */
	function disablePhoneLinksOnComputers( $phoneLinks ) {
		if( isMobile() ) {
			return; /* [1] */
		}
		if( !$phoneLinks.length ) {
			return; /* [2] */
		}
		$phoneLinks.each(function(i, phoneLink) {
			var $phoneLink = $(phoneLink);
			$phoneLink.contents().unwrap();
		});
	}

	//	======================================================================  //
	//	On ready
	//	======================================================================  //

	onReady.callbacks.phoneNumbers = function() {
		disablePhoneLinksOnComputers( $phoneNumbers );
	};

})();
